module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Y1N75K/images/cover.jpg?1732976220438",
      "alt": "This image is the cover for the book Kruton Interface"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kruton Interface\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Laughs abound when a planet of (literally) slimy lawyers prosecutes an unemployed space captain—from the bestselling author of the Castle Perilous series. ")]), _c('br'), _c('br'), _vm._v(" Captain David Wanker thought his career had hit rock bottom. Then he was assigned to the starship Repulse, the lowest-rated ship in the Space Forces. The navigator gets lost, the engineer speaks only Gaelic, the security personnel have narcolepsy, and the ship's doctor needs medication. No sooner than he takes command, his job as captain is lost to automation invented by a mad scientist who thinks he's Groucho Marx. Worse yet, when he meets up with the inhabitants of the planet Kruton, a world that is one huge law firm, he finds himself a defendant in the biggest lawsuit ever to hit the Galactic courts. Hilarity not only ensues--it practically goes supernova!"), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _vm._v(" \"Unerring Marxmanship. This book would have left Harpo speechless.\" -- \"William Tenn\" (classic science fiction author, pseudonym of Philip Klass)"), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _vm._v(" \"Madcap science fantasy--fun filled adventure!\" -- Booklist"), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _c('br', {
    staticStyle: {
      "color": "rgb(88, 89, 91)",
      "font-family": "Verdana, Geneva, sans-serif"
    }
  }), _vm._v(" \"DeChancie always delivers!\" -- Mike Resnick (Hugo Award winner) \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John DeChancie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John DeChancie is a popular author of numerous science fiction and fantasy novels, including the hugely entertaining Castle series and the Starrigger trilogy. He grew up near Pittsburgh, Pennsylvania, and now lives in Los Angeles, California.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0